import React from 'react';
import EquipmentManagementPage from './EquipmentManagementPage';

const EquipmentManagementContainer = () => {
  return (
    <div style={{ padding: '16px 20px', width: '100%', maxWidth: '100%' }}>
      <EquipmentManagementPage />
    </div>
  );
};

export default EquipmentManagementContainer;
